const enTranslation = {
    // Common
    language: "English",

    // Navigation
    navigation: {
        overview: "Overview",
        solutions: "Solutions",
        features: "Features",
        pricing: "Pricing",
        testimonials: "Testimonials",
        partners: "Partners",
        login: "Log In",
        dashboard: "Dashboard"
    },

    // Footer
    footer: {
        aboutUs: "About Us",
        resources: "Resources",
        legal: "Legal",
        linkedIn: "LinkedIn",
        faq: "FAQ",
        customerSupport: "Customer Support",
        contactUs: "Contact Us",
        privacyPolicy: "Privacy Policy",
        termsConditions: "Terms & Conditions",
        rights: "All Rights Reserved."
    },

    // Pricing page
    pricing: {
        title: "Pricing",
        subtitle: "Find the right plan for your needs",
        setupFee: "one-time setup fee",
        bookMeeting: "Book a meeting",
        features: {
            fast: "Fast and reliable",
            fastDesc: "We've made it fast and reliable."
        },
        plans: {
            timeRegistration: {
                name: "Time Registration",
                description: "Simple, mandatory and cost-effective time tracking solution",
                features: {
                    legalCompliance: {
                        title: "Legal Compliance",
                        description: "EU & Danish work time regulations"
                    },
                    automaticTracking: {
                        title: "Automatic Tracking",
                        description: "Precise GPS tracking, geofencing & mobile login"
                    },
                    userFriendly: {
                        title: "User-Friendly Interface",
                        description: "Works on all devices"
                    },
                    timePolicy: {
                        title: "Time registration policy",
                        description: "495 per contract"
                    }
                }
            },
            drivingAllowance: {
                name: "Driving Allowance",
                description: "Eliminate manual registration and ensure tax-compliant mileage reimbursement",
                features: {
                    gpsTracking: {
                        title: "GPS-Based Tracking",
                        description: "Automatic precise mileage documentation"
                    },
                    taxCompliance: {
                        title: "Tax Authority Compliance",
                        description: "Calculations according to tax rules"
                    },
                    accounting: {
                        title: "Accounting Integration",
                        description: "Export data to financial systems"
                    },
                    dashboard: {
                        title: "Management Dashboard",
                        description: "Oversight and approval workflows"
                    }
                }
            },
            co2: {
                name: "Drivn CO₂",
                description: "Track and reduce your company's carbon footprint",
                features: {
                    automatedCalc: {
                        title: "Automated Calculations",
                        description: "Precise CO₂ emission tracking"
                    },
                    dashboard: {
                        title: "Real-time Dashboard",
                        description: "Visual analytics and monitoring"
                    },
                    esgCompliance: {
                        title: "ESG Compliance",
                        description: "Regulatory reporting support"
                    },
                    integration: {
                        title: "System Integration",
                        description: "Works with your existing software"
                    }
                }
            },
            allInOne: {
                name: "All-in-One solution",
                description: "Integrate time tracking, mileage reimbursement and CO₂ monitoring in one unified platform",
                features: {
                    complete: {
                        title: "Complete Solution",
                        description: "All modules in one integrated package"
                    },
                    reporting: {
                        title: "Consolidated Reporting",
                        description: "Combined analytics and dashboards"
                    },
                    integration: {
                        title: "Enterprise Integration",
                        description: "Seamless connection to your systems"
                    }
                },
                popular: "Popular"
            }
        },
        perMonth: "/ month",
        perContract: "per contract"
    },

    // Plan names
    plans: {
        timeRegistration: "Time Registration",
        drivingAllowance: "Driving Allowance",
        growth: "Growth",
        enterprise: "Enterprise"
    },

    // Plan descriptions
    planDescriptions: {
    },

    // Login page
    login: {
        title: "Log in to your account",
        email: "Your email",
        emailPlaceholder: "name@company.com",
        password: "Password",
        passwordPlaceholder: "••••••••",
        rememberMe: "Remember me",
        forgotPassword: "Forgot password?",
        loginButton: "Log in"
    },

    // Contact Sales page
    contactSales: {
        title: "Contact Sales"
    },

    // Features page
    features: {
        title: "Features",
        subtitle: "Powerful features for your business",
        description: "We provide tools that help you manage your business efficiently."
    },

    // Overview page
    overview: {
        title: "Overview",
        subtitle: "Your business at a glance",
        description: "Get a comprehensive view of your business performance."
    },

    // Home page
    home: {
        title: "Home",
        main: {
            title: {
                get: "Get",
                actionable: "actionable",
                insights: "insights and tools for employee transportation"
            },
            subtitle: "Say goodbye to inconsistent and low-quality data from employee surveys and welcome our fully automatic solution to effortlessly monitor, analyse, and optimise your company's transportation impact, with real-time data",
            getStartedButton: "Get Started",
            learnMoreButton: "Learn More",
            dashboardAltDark: "Dashboard Preview Dark Mode",
            dashboardAltLight: "Dashboard Preview Light Mode"
        },
        overviewSection: {
            app: {
                title: "Drivn App: Empower Your Employee's Eco-Conscious Commute",
                description: "Elevate your employee's daily commute with the Drivn App. Designed with simplicity and sustainability in mind, our app enables effortless registration and management of employee's travel. Track carbon footprint, join green initiatives, and support environmental goals automatically.",
                features: {
                    registration: {
                        title: "Seamless Registration:",
                        text: "Sign up with your organization's code in seconds."
                    },
                    noEngage: {
                        title: "No need to engage in the app:",
                        text: "Automatically logs in the background with zero input needed."
                    },
                    realTime: {
                        title: "Real-Time Data:",
                        text: "View your work related transportation emissions in real time."
                    },
                    greenGoals: {
                        title: "Green Goals:",
                        text: "Join company challenges and contribute to sustainability targets."
                    }
                }
            },
            dashboard: {
                title: "Drivn Dashboard: Insightful Oversight for Sustainability",
                description: "Transition to transparent and automated carbon accounting with Drivn's Dashboard. Managers gain a comprehensive view of the company's transportation emissions and trends. Harness the power of data to drive strategic decisions, meet compliance, and lead the way in corporate responsibility.",
                features: {
                    aggregated: {
                        title: "Aggregated Data:",
                        text: "Get a bird's-eye view of company-wide commuting data."
                    },
                    compliance: {
                        title: "Compliance Simplified:",
                        text: "Tools tailored to meet CSRD and ESG reporting."
                    },
                    insights: {
                        title: "Actionable Insights:",
                        text: "Analyze trends and measure the effectiveness of green policies."
                    },
                    engage: {
                        title: "Engage and Educate:",
                        text: "Access resources to foster a culture of sustainability."
                    }
                }
            },
            charts: {
                emissions: {
                    title: "{{totalEmissions}} kg",
                    subtitle: "CO₂ Emissions",
                    seriesName: "Emissions",
                    yAxisLabel: "{{value}}kg"
                },
                commutes: {
                    subtitle: "Amount of commutes",
                    seriesName: "Commutes"
                },
                transport: {
                    mostUtilized: "Most Utilized Transportation Method",
                    mostUtilizedValue: "Car",
                    methods: {
                        car: "Car",
                        bus: "Bus",
                        train: "Train",
                        bike: "Bike",
                        walking: "Walking"
                    },
                    tooltipFormat: "{{value}} km"
                },
                months: {
                    jan: "Jan",
                    feb: "Feb",
                    mar: "Mar",
                    apr: "Apr",
                    may: "May",
                    jun: "Jun"
                }
            }
        },
        featuresSection: {
            mainTitle: "Designed for sustainability teams like yours",
            mainDescription: "At Drivn we focus on leveraging advanced technologies and creativity to unlock emissions data never seen before",
            highQualityData: {
                title: "High Quality Data",
                description: "Eliminate human error and ensure high-quality data with our fully automatic tracking."
            },
            automated: {
                title: "100% Automated",
                description: "Our mobile app leverages machine learning and adaptive geofencing to automatically identify and calculate emissions from work-related commutes."
            },
            insights: {
                title: "Valuable Insights",
                description: "Educate your employees in their commuting habits and related emissions."
            },
            compliance: {
                title: "Compliance",
                description: "Our web-based admin panel aggregates real-time data, helping you meet CSRD and ESG requirements effortlessly."
            }
        },
        productsSolutions: {
            title: "Our Solutions",
            subtitle: "Discover how Drivn automates mileage tracking, ensures compliance, and integrates smoothly with your workflow.",
            products: {
                tracking: {
                    id: "tracking",
                    title: "Drivn CO₂ tracking",
                    description: "Drivn CO₂ is an innovative and user-friendly system that helps companies record, monitor and reduce their carbon footprint. With automated data collection, Drivn CO₂ makes it easy to document environmental impact and meet ESG requirements and regulatory reporting standards.",
                    bulletPoints: [
                        { title: "Automated CO₂ calculation:", text: "Collects and analyzes data from company activities to provide accurate CO₂ reporting." },
                        { title: "Live overview of emissions:", text: "Intuitive dashboard with real-time data and visual analytics." },
                        { title: "Compliance & ESG reporting:", text: "Supports documentation for authorities, investors and certification schemes." },
                        { title: "Optimization of sustainability strategies:", text: "Identifies CO₂-heavy processes and suggests effective reduction measures." },
                        { title: "Integration with existing systems:", text: "Easy setup and compatibility with finance, transport and production software." },
                    ],
                    additionalInfo: "Our CO₂ tracking solution is designed to help your business meet sustainability goals while simplifying regulatory compliance. The system adapts to your specific industry needs."
                },
                driving: {
                    id: "compliance",
                    title: "Drivn Automated Driving Allowance",
                    description: "Drivn offers an automated driving allowance solution that eliminates manual registration and ensures accurate calculations in accordance with the Danish Tax Agency's regulations. With GPS tracking and automatic logging of kilometers driven, the system reduces administrative burdens and minimizes the risk of errors.",
                    bulletPoints: [
                        { title: "Automatic driving allowance registration:", text: "GPS-based registration ensures accurate documentation of kilometers driven" },
                        { title: "Complies with tax requirements:", text: "The system calculates and documents driving allowance according to applicable legislation." },
                        { title: "Integration with accounting systems:", text: "Export data directly to the company's financial system for easy bookkeeping." },
                        { title: "Time-saving solution:", text: "Eliminates the need for manual driving accounts and reduces administrative work." },
                        { title: "User-friendly mobile and web platform:", text: "Employees can easily approve and submit driving data with a few clicks." },
                        { title: "Increased transparency and control:", text: "Managers get a clear overview of employees' business driving." }
                    ],
                    additionalInfo: "With Drivn Automated Driving Allowance, companies get a reliable and scalable solution that ensures correct registration, reduces time consumption and makes it easier to comply with regulatory requirements."
                },
                timeRegistration: {
                    id: "integration",
                    title: "Drivn Time Regisration",
                    description: "Drivn offers the market’s most user‑friendly and affordable Time Regisration system, ensuring your company complies with working‑time legislation and giving you a clear overview of employees’ hours. With a fully digital and automated solution, Drivn makes time registration easy for both employees and managers while safeguarding the business legally.",
                    bulletPoints: [
                        { title: "Mandatory time tracking", text: "Complies with the EU Working Time Directive and Danish working‑time regulations." },
                        { title: "Automatic recording:", text: "Accurate logging of working hours via GPS, geofencing, and mobile login." },
                        { title: "Simple interface:", text: "Employees can clock in and out effortlessly using a smartphone, tablet, or desktop." },
                        { title: "Full flexibility:", text: "Supports fixed schedules, shift work, and flexible hours." },
                        { title: "Reports and payroll integration:", text: "Generates clear reports and integrates with payroll systems." } 
                    ],
                    additionalInfo: "With Drivn, you get a Time Regisration system that saves time, ensures compliance, and reduces administrative burden. The solution suits companies of all sizes that want efficient, hassle‑free registration of working hours."
                }
            }
        }
    },

    // Contact page
    contact: {
        pageTitle: "Contact Support",
        title: "Contact Us",
        description: "Got a technical issue? Want to send feedback about a beta feature? Need details about our Business plan? Let us know.",
        email: "Your email",
        emailPlaceholder: "name@company.com",
        subject: "Subject",
        subjectPlaceholder: "The subject of your issue",
        message: "Your message",
        messagePlaceholder: "The content of your issue",
        submit: "Send message"
    },

    // FAQ page
    faq: {
        pageTitle: "FAQ",
        title: "Frequently asked questions",
        questions: {
            howItWorks: {
                question: "How does Drivn work?",
                answer: "Drivn utilises a mobile application that employees can download to their smartphones. The app uses geofencing and machine learning to distinguish between personal and work-related transportation. This allows us to automatically provide accurate data on carbon emissions generated during employee commutes. Individual data will be available for the employee directly in the application, while the aggregated data will be displayed through a dashboard in the Drivn admin panel."
            },
            benefits: {
                question: "What are the benefits of using Drivn?",
                bulletPoints: [
                    "Compliance: Drivn helps businesses comply with environmental regulations by providing real-time data on carbon emissions.",
                    "Employee Engagement: Our platform makes sustainable commuting a friendly competition among employees, fostering a culture of eco-friendly practices.",
                    "Data-Driven Insights: Drivn offers valuable insights into commuting patterns, allowing companies to make informed decisions for a greener future."
                ]
            },
            privacy: {
                question: "How is user privacy protected?",
                answer: "We take user privacy seriously. Drivn adheres to all relevant data protection laws within the EU, and users have control over their data. We provide clear information about the data we collect and how it is used, and users can opt-out or disable location tracking at any time. A data processor agreement in accordance with EU standards and The Danish Data Protection Agency is made between the client and Drivn upon company onboarding. Further information can be found within our Privacy Policy and User Consent."
            },
            getStarted: {
                question: "How can my company get started with Drivn?",
                answer: "Getting started is easy! Simply reach out to our team, and we'll guide you through the setup process. We'll help you customise the app for your organisation, provide training for your employees, and ensure a seamless integration into your sustainability initiatives."
            },
            compliance: {
                question: "Can Drivn help with regulatory compliance?",
                answer: "Absolutely. Drivn is designed to assist businesses in meeting regulatory requirements, especially in the context of GHG Protocol: scope 3 category 7 emissions (Employee Commuting)."
            },
            dataInsights: {
                question: "How frequently does Drivn provide data insights?",
                answer: "Drivn provides real-time insights, allowing businesses to access real time-data and information on commuting patterns and carbon emissions. This ensures that organisations can make timely decisions to reduce their environmental impact."
            },
            userExpectations: {
                question: "What is expected from the user in utilising the Drivn app?",
                answer: "To ensure a seamless experience and accurate data collection, users (employees) are encouraged to follow these guidelines:",
                steps: [
                    "Download and Register: Users should download the Drivn app from the provided link and register using their organisation's unique code.",
                    "Activate Location Services: To enable precise tracking, users must activate the \"allow always\" option of location services for the Drivn app. Drivn utilises location data responsibly and respects user privacy.",
                    "Hereafter, no further engagement is required from the user's perspective, however analytics and statistics is available for the user to view if wanted."
                ]
            },
            transportModes: {
                question: "What types of transportation modes does Drivn cover?",
                answer: "Drivn comprehensively covers various transportation modes, ensuring a complete analysis of your organisation's carbon footprint. The supported modes include:",
                modes: [
                    "Car: Whether it's a company car or personal vehicle, Drivn tracks carbon emissions associated with car commuting.",
                    "Train and Metro: For employees using public transportation, Drivn accurately records emissions related to train travel.",
                    "Walking and Biking: Drivn recognizes sustainable modes of transportation, such as walking and biking, contributing to a holistic view of your environmental impact.",
                    "Bus: Drivn also includes bus transportation in its tracking capabilities.",
                    "Other transportation modes covered: Ferry, Tram, Subway."
                ]
            }
        },
        userConsent: "User Consent"
    },

    // Forgot Password page
    forgotPassword: {
        pageTitle: "Forgot Password",
        title: "Reset your password",
        subtitle: "Enter your email here and we'll send you an email where you can reset your password.",
        email: "Your email",
        emailPlaceholder: "name@company.com",
        resetButton: "Reset Password",
        sending: "Sending Password Reset...",
        error: "An Error Occurred",
        tryAgain: "Try Again",
        checkEmail: "Check your email! (And Spam)",
        goToLogin: "Go To Log In"
    },

    // Not Found page
    notFound: {
        pageTitle: "404",
        title: "Page not found",
        subtitle: "Sorry, we couldn't find the page you're looking for.",
        goHome: "Go back home",
        contactSupport: "Contact support"
    },

    termsAndConditions: {
        pageTitle: "Terms and Conditions"
    },

    privacyPolicy: {
        pageTitle: "Privacy Policy"
    },

    // Dashboard
    dashboard: {
        tabs: {
            analytics: "Analytics",
            employees: "Employees",
            departments: "Departments",
            offices: "Offices",
            settings: "Settings"
        },
        logout: "Logout",
        organizationCode: "Organization Code:",
        copied: "Copied to clipboard",
        loading: "Loading User...",
        notAdmin: {
            title: "This page is only accessible to admins",
            greeting: "Hi",
            message: "at the moment this page is accessible to admin users. If you should have access to your organization's analytics,",
            contact: "contact your organization administrator at",
            persist: "If the issue persists,",
            support: "contact support"
        },
        analytics: {
            emissions: {
                title: "CO₂ Emissions",
                unit: "kg",
                increased: "You spent {{value}} kg compared to the last time period",
                decreased: "You saved {{value}} kg this time period",
                chart: {
                    downloadButton: "Download Custom CSV",
                    day: "Day",
                    date: "Date",
                    emission: "Emission",
                    total: "Total",
                    months: [
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                    ]
                }
            },
            commutes: {
                title: "Amount of commutes",
                seriesName: "Commutes"
            }
        },
        employees: {
            title: "All Users",
            breadcrumb: {
                dashboard: "Dashboard",
                allEmployees: "All Employees"
            },
            tableHeaders: {
                user: "User",
                userRole: "User Role",
                department: "Department",
                status: "Status"
            },
            pagination: {
                showing: "Showing",
                of: "of",
                previous: "Previous",
                next: "Next"
            },
            loading: "Loading Employees...",
            employeeCell: {
                roles: {
                    owner: "Owner",
                    administrator: "Administrator",
                    employee: "Employee"
                },
                status: {
                    active: "Active",
                    removed: "Removed"
                },
                noSelection: "Hasn't Selected",
                delete: "Delete"
            }
        }
    }
};

export default enTranslation;